<template>
  <div class="house-list-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">租房系统</el-breadcrumb-item>
      <el-breadcrumb-item>房源列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div class="filter-container">
        <el-form :inline="true" :model="filterForm" class="demo-form-inline">
          <el-form-item label="房源名称">
            <el-input v-model="filterForm.title" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="房源价格">
            <el-input v-model="filterForm.amount" placeholder="请选择内容"></el-input>
          </el-form-item>
          <el-form-item label="所属大学">
            <el-input v-model="filterForm.college" placeholder="请输入大学名称"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filterForm.status" placeholder="请选择内容状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="闲置" value="0"></el-option>
              <el-option label="在租" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
          <el-form-item style="float:right;">
            <el-button type="primary" @click="showUploadDialog()">
              <i class="el-icon-upload2"></i> 上架
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="house-type-filter">
        <span>出租类型</span>
        <el-select v-model="filterForm.type" placeholder="全部" style="width: 120px; margin-left: 10px;">
          <el-option label="全部" value=""></el-option>
          <el-option label="整租" value="整租"></el-option>
          <el-option label="合租" value="合租"></el-option>
        </el-select>
      </div>

      <div class="table-container">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="name" label="房源名称"></el-table-column>
          <el-table-column prop="statusText" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="getStatusTagType(scope.row.status)"
                size="medium">
                {{ scope.row.statusText }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" width="100"></el-table-column>
          <el-table-column prop="price" label="价格" width="120"></el-table-column>
          <el-table-column prop="browseNumbers" label="浏览数" width="80"></el-table-column>
          <el-table-column prop="college" label="所属大学" width="80"></el-table-column>
          <el-table-column prop="listDate" label="上架日期" width="120"></el-table-column>
          <el-table-column prop="availableDate" label="可租日期" width="120"></el-table-column>
          <el-table-column prop="remark" label="备注" width="120"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="handleUnlist(scope.row)">下架</el-button>
              <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <div class="total-info">共 {{total}} 项数据</div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 房源上传对话框 -->
    <house-upload
      :visible.sync="uploadVisible"
      :is-edit="isEdit"
      :edit-data="currentHouse"
      @submit-success="handleUploadSuccess">
    </house-upload>

    <!-- 房源管理对话框 - 第一种（租金信息） -->
    <el-dialog
      title="房源管理"
      :visible.sync="rentInfoVisible"
      width="700px"
      :before-close="handleCloseDialog">
      <div class="rent-info-dialog">
        <div class="section">
          <h3>租客信息</h3>
          <div class="info-row">
            <div class="info-item">
              <span class="label">租房人姓名</span>
              <span class="value">{{ rentInfo.tenantName }}</span>
            </div>
            <div class="info-item">
              <span class="label">押金</span>
              <span class="value">{{ rentInfo.deposit }}元</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">租房人身份证号</span>
              <span class="value">{{ rentInfo.tenantIdCard }}</span>
            </div>
            <div class="info-item">
              <span class="label">支付日期</span>
              <span class="value">{{ rentInfo.paymentDate }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">手机号</span>
              <span class="value">{{ rentInfo.phone }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">入住时间</span>
              <span class="value">{{ rentInfo.checkInDate }}</span>
            </div>
          </div>
        </div>

        <div class="section">
          <h3>租金</h3>
          <div class="info-row">
            <div class="info-item">
              <span class="label">租金</span>
              <span class="value">{{ rentInfo.rentAmount }}元/月</span>
            </div>
            <div class="info-item">
              <span class="label">状态</span>
              <span class="value">{{ rentInfo.status }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">缴租周期</span>
              <span class="value">{{ rentInfo.rentCycle }} (每月{{ rentInfo.rentDay }}日) <span class="tag">待缴租</span></span>
            </div>
            <div class="info-item">
              <span class="label">套餐类型</span>
              <span class="value">{{ rentInfo.packageType }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">出租时间</span>
              <span class="value">{{ rentInfo.rentStartDate }}</span>
            </div>
            <div class="info-item">
              <span class="label">购买时间</span>
              <span class="value">{{ rentInfo.purchaseDate }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">到期时间</span>
              <span class="value">{{ rentInfo.rentEndDate }}</span>
            </div>
            <div class="info-item">
              <span class="label">到期时间</span>
              <span class="value">{{ rentInfo.packageEndDate }}</span>
            </div>
          </div>
        </div>

        <div class="actions">
          <el-button @click="handleMarkEmptyHouse">标记空房</el-button>
          <el-button type="primary" @click="handleRenewRent">续租</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 房源管理对话框 - 第二种（租客信息和操作） -->
    <el-dialog
      title="房源管理"
      :visible.sync="tenantInfoVisible"
      width="700px"
      :before-close="handleCloseDialog">
      <div class="tenant-info-dialog">
        <div class="tabs-section">
          <div class="tab-header">
            <div class="tab-item active">
              <img src="" alt="" class="avatar" />
            </div>
          </div>
          <div class="user-info">
            <div class="user-row">
              <div class="user-field">用户昵称</div>
              <div class="user-value">{{ tenantInfo.nickname }}</div>
            </div>
            <div class="user-row">
              <div class="user-field">性别</div>
              <div class="user-value">{{ tenantInfo.gender }}</div>
            </div>
            <div class="user-row">
              <div class="user-field">手机号</div>
              <div class="user-value">{{ tenantInfo.phone }}</div>
            </div>
            <div class="user-row">
              <div class="user-field">随心住服务包</div>
              <div class="user-value">{{ tenantInfo.packageStatus }}</div>
            </div>
            <div class="user-row">
              <div class="user-field">维护状态</div>
              <div class="user-value">{{ tenantInfo.maintenanceStatus }}</div>
            </div>
          </div>
        </div>

        <div class="tenant-basic-info">
          <div class="tenant-row">
            <div class="tenant-field">租房人姓名</div>
            <div class="tenant-value">{{ tenantInfo.name }}</div>
          </div>
          <div class="tenant-row">
            <div class="tenant-field">租房人身份证号</div>
            <div class="tenant-value">{{ tenantInfo.idCard }}</div>
          </div>
          <div class="tenant-row">
            <div class="tenant-field">手机号</div>
            <div class="tenant-value">{{ tenantInfo.phone }}</div>
          </div>
          <div class="tenant-row">
            <div class="tenant-field">入住时间</div>
            <div class="tenant-value">{{ tenantInfo.checkInDate }}</div>
          </div>
        </div>

        <div class="actions">
          <el-button @click="handleRescindRent">放弃租房</el-button>
          <el-button type="primary" @click="handleCompleteRent">出租成功</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HouseUpload from './houseUpload.vue'
import { getReq, postRed } from '@/api/axiosFun'

export default {
  name: 'HouseList',
  components: {
    HouseUpload
  },
  data() {
    return {
      filterForm: {
        title: '',
        amount: '',
        status: '',
        type: '',
        college: ''
      },
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      uploadVisible: false,
      isEdit: false,
      currentHouse: null,

      // 房源管理弹框 - 第一种（已出租状态）
      rentInfoVisible: false,
      rentInfo: {
        tenantName: '李思维',
        deposit: '500',
        tenantIdCard: '366666888811112121',
        paymentDate: '2025-03-01',
        phone: '18888888888',
        checkInDate: '2025-03-01',
        rentAmount: '1960',
        status: '生效中',
        rentCycle: '月付 (每月20日)',
        rentDay: '20',
        packageType: '年费',
        rentStartDate: '2025-03-01',
        purchaseDate: '2025-03-01',
        rentEndDate: '2026-03-01',
        packageEndDate: '2026-03-01'
      },

      // 房源管理弹框 - 第二种（看房中状态）
      tenantInfoVisible: false,
      tenantInfo: {
        nickname: '十八',
        gender: '男',
        phone: '18888888888',
        packageStatus: '已购买',
        maintenanceStatus: '未跟进',
        name: '李思维',
        idCard: '366666888811112121',
        checkInDate: '2025-03-01'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    showUploadDialog(isEdit = false, house = null) {
      this.isEdit = isEdit;
      this.currentHouse = house;
      this.uploadVisible = true;
    },
    getStatusTagType(status) {
      const statusMap = {
        0: 'info',    // 闲置状态使用info类型
        1: 'success'  // 在租状态使用success类型
      };
      return statusMap[status] || 'info';
    },
    getList() {
      // 构建API请求参数，只包含必需参数
      const params = {
        page: this.pageSize,  // 修改这里，page表示每页条数
        limit: this.currentPage, // 修改这里，limit表示页码
        address: this.filterForm.title || '',      // 地址（使用title字段值）
        bigAmount: this.filterForm.amount ? this.filterForm.amount.split('-')[1] || '' : '',   // 最大价格
        bigProportion: '',                         // 最大面积
        checkTime: '',                             // 入住时间
        college: this.filterForm.college || '',     // 大学
        housePattern: '',                          // 户型
        leaseTerm: '',                             // 租期
        orientation: '',                           // 朝向
        smallAmount: this.filterForm.amount ? this.filterForm.amount.split('-')[0] || '' : '', // 最小价格
        smallProportion: '',                       // 最小面积
        sort: '',                                  // 排序
        status: this.filterForm.status || '',      // 状态（0-闲置，1-在租）
        type: this.filterForm.type || ''           // 类型（整租/合租）
      };

      // 使用通用请求方法
      getReq('get', '/rentHouse/selectAllHouse', params)
        .then(response => {
          // 直接使用返回的数据，检查status而不是code
          const responseData = response.data || {};

          if (responseData) {
            this.tableData = (responseData.list || []).map(item => {
              // 转换API返回的数据为表格所需的格式
              return {
                id: item.id,                            // 主键ID
                name: item.title || `${item.type} ${item.address}`, // 显示名称
                type: item.type || '整租',              // 租房类型（整租/合租）
                price: `${item.amount}/月`,            // 租金价格
                browseNumbers: item.browseNumbers || 0,  // 浏览数
                college: item.college || '',           // 所属大学
                listDate: item.createdAt ? this.formatDate(item.createdAt) : '', // 创建时间
                availableDate: item.checkTime ? this.formatDate(item.checkTime) : '', // 入住时间
                remark: item.remark || '',              // 备注信息
                status: item.status !== undefined ? item.status : 0,  // 状态码
                statusText: this.getStatusText(item.status), // 状态文本

                // 保存原始数据，方便编辑时使用
                title: item.title,                      // 标题
                address: item.address,                  // 地址
                amount: item.amount,                    // 原始金额
                proportion: item.proportion,            // 面积
                orientation: item.orientation,          // 朝向
                floor: item.floor,                      // 楼层
                phoneNumber: item.phoneNumber,          // 联系电话
                videoUrl: item.videoUrl,                // 视频URL
                imageUrlJson: item.imageUrlJson,        // 图片URL JSON
                imageUrl: item.imageUrl,                // 图片URL数组
                isLift: item.isLift,                    // 是否有电梯
                isDomestic: item.isDomestic,            // 是否民用水电
                isPropertyFee: item.isPropertyFee,      // 是否包含物业费
                isShortRent: item.isShortRent,          // 是否短租
                enableType: item.enableType,            // 是否启用
                weChatWorkImage: item.weChatWorkImage,  // 企业微信图片
                checkTime: item.checkTime,              // 入住时间
                housePattern: item.housePattern,        // 户型
                leaseTerm: item.leaseTerm,              // 租期
                createdAt: item.createdAt,              // 创建时间
                updatedAt: item.updatedAt,              // 更新时间
              };
            });

            this.total = responseData.totalRow || 0;
          } else {
            this.$message.error((responseData && responseData.statusText) || '获取房源列表失败');
            this.tableData = [];
            this.total = 0;
          }
        }).catch(error => {
          console.error('获取房源列表错误:', error);
          this.$message.error('获取房源列表失败，请重试');
          this.tableData = [];
          this.total = 0;
        });
    },
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    // 根据状态码获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '闲置',
        1: '在租'
      };
      return statusMap[status] || '未知状态';
    },
    handleSearch() {
      this.currentPage = 1
      this.getList()
    },
    resetForm() {
      this.filterForm = {
        title: '',
        amount: '',
        status: '',
        type: '',
        college: ''
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    handleEdit(row) {
      // 使用上架弹框进行编辑，将原始数据传递给对话框
      const editData = {
        id: row.id,
        title: row.title,
        address: row.address,
        amount: row.amount,
        type: row.type,
        status: row.status,
        proportion: row.proportion,
        orientation: row.orientation,
        floor: row.floor,
        phoneNumber: row.phoneNumber,
        videoUrl: row.videoUrl,
        imageUrlJson: row.imageUrlJson,
        imageUrl: row.imageUrl || [],
        isLift: row.isLift,
        isDomestic: row.isDomestic,
        isPropertyFee: row.isPropertyFee,
        isShortRent: row.isShortRent,
        enableType: row.enableType,
        weChatWorkImage: row.weChatWorkImage,
        checkTime: row.checkTime,
        housePattern: row.housePattern,
        leaseTerm: row.leaseTerm,
        college: row.college,
        browseNumbers: row.browseNumbers,
        createdAt: row.createdAt,
        updatedAt: row.updatedAt,
        deletedAt: row.deletedAt,
        remark: row.remark
      };
      this.showUploadDialog(true, editData);
    },
    handleUnlist(row) {
      this.$confirm('确认下架该房源?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除房源API
        this.deleteHouse(row.id);
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    deleteHouse(id) {
      // 调用删除房源接口
      // 组装请求参数
      const params = {
        id: id
      };

      // 使用通用请求方法
      getReq('get', '/rentHouse/deleteHouse', params)
        .then(response => {
          // 接口返回200就是成功
          if (response.status === 200) {
            this.$message.success('房源下架成功');
            this.getList(); // 刷新列表
          } else {
            this.$message.error('下架失败，请重试');
          }
        }).catch(error => {
          console.error('下架房源错误:', error);
          this.$message.error('下架失败，请重试');
        });
    },
    handleManage(row) {
      // 根据房源状态打开不同的管理弹框
      if(row.status === 1) { // 在租状态
        this.rentInfoVisible = true; // 打开租金信息弹框
      } else {
        this.$message.info('闲置状态无管理操作');
      }
    },
    handleUploadSuccess(data) {
      // 显示统一的成功提示
      this.$message.success(this.isEdit ? '房源编辑成功' : '房源上传成功');

      if (this.isEdit) {
        // 调用更新房源接口，传入false表示不显示提示
        this.updateHouse(data, false);
      } else {
        // 调用发布房源接口，传入false表示不显示提示
        this.publishHouse(data, false);
      }
    },
    updateHouse(houseData, showNotice = true) {
      // 调用更新房源接口
      // 准备房源数据，根据接口参数要求
      const rentHouse = {
        // 主键ID
        id: houseData.id,
        // 基本信息
        title: houseData.title || houseData.name,      // 标题
        type: houseData.type || '整租',                // 类型（整租/合租）
        proportion: houseData.proportion || '',        // 面积
        orientation: houseData.orientation || '',      // 朝向
        status: houseData.status !== undefined ? houseData.status : 0,  // 状态 (0-闲置，1-在租)
        floor: houseData.floor || '',                  // 楼层
        address: houseData.address || '',              // 地址
        amount: parseFloat(houseData.amount || houseData.price) || 0,  // 价格
        isShortRent: houseData.isShortRent === true || houseData.isShortRent === 1 ? true : false,  // 是否可以短租
        isPropertyFee: houseData.isPropertyFee === true || houseData.isPropertyFee === 1 ? true : false, // 是否包含物业费
        isDomestic: houseData.isDomestic === true || houseData.isDomestic === 1 ? true : false,     // 是否民用水电
        isLift: houseData.isLift === true || houseData.isLift === 1 ? true : false,             // 是否有电梯
        phoneNumber: houseData.phoneNumber || '',     // 联系电话
        videoUrl: houseData.videoUrl || '',           // 视频地址
        imageUrlJson: JSON.stringify(houseData.imageUrl || []), // 图片URL JSON格式
        imageUrl: houseData.imageUrl || [],           // 图片URL数组
        enableType: houseData.enableType === true || houseData.enableType === 1 ? true : false,     // 是否启用
        weChatWorkImage: houseData.weChatWorkImage || '', // 企业微信图片
        checkTime: houseData.checkTime || '',         // 入住时间
        housePattern: houseData.housePattern || '',   // 户型
        leaseTerm: houseData.leaseTerm || '',         // 租期
        college: houseData.college || '',              // 大学
      };

      // 使用通用请求方法
      postRed('post', '/rentHouse/updateHouse', rentHouse)
        .then(response => {
          // 直接检查请求是否成功
          if (response.status === 200) {
            this.getList(); // 刷新列表
            if (showNotice) {
              this.$message.success('房源编辑成功');
            }
          } else {
            this.$message.error((response.data && response.data.message) || '编辑失败，请重试');
          }
        }).catch(error => {
          console.error('编辑房源错误:', error);
          this.$message.error('编辑失败，请重试');
        });
    },
    publishHouse(houseData, showNotice = true) {
      // 调用发布房源接口
      // 准备房源数据，根据接口参数要求
      const rentHouse = {
        // 基本信息
        title: houseData.title || houseData.name,      // 标题
        type: houseData.type || '整租',                // 类型（整租/合租）
        proportion: houseData.proportion || '',        // 面积
        orientation: houseData.orientation || '',      // 朝向
        status: houseData.status !== undefined ? houseData.status : 0,  // 状态 (0-闲置，1-在租)
        floor: houseData.floor || '',                  // 楼层
        address: houseData.address || '',              // 地址
        amount: parseFloat(houseData.amount || houseData.price) || 0,  // 价格
        isShortRent: houseData.isShortRent === true || houseData.isShortRent === 1 ? true : false,  // 是否可以短租
        isPropertyFee: houseData.isPropertyFee === true || houseData.isPropertyFee === 1 ? true : false, // 是否包含物业费
        isDomestic: houseData.isDomestic === true || houseData.isDomestic === 1 ? true : false,     // 是否民用水电
        isLift: houseData.isLift === true || houseData.isLift === 1 ? true : false,             // 是否有电梯
        phoneNumber: houseData.phoneNumber || '',     // 联系电话
        videoUrl: houseData.videoUrl || '',           // 视频地址
        imageUrlJson: JSON.stringify(houseData.imageUrl || []), // 图片URL JSON格式
        imageUrl: houseData.imageUrl || [],           // 图片URL数组
        enableType: houseData.enableType === true || houseData.enableType === 1 ? true : false,     // 是否启用
        weChatWorkImage: houseData.weChatWorkImage || '', // 企业微信图片
        checkTime: houseData.checkTime || '',         // 入住时间
        housePattern: houseData.housePattern || '',   // 户型
        leaseTerm: houseData.leaseTerm || '',         // 租期
        college: houseData.college || '',              // 大学
      };

      // 使用通用请求方法
      postRed('post', '/rentHouse/insertHouse', rentHouse)
        .then(response => {
          // 直接检查请求是否成功
          if (response.status === 200) {
            this.getList(); // 刷新列表
            if (showNotice) {
              this.$message.success('房源上传成功');
            }
          } else {
            this.$message.error((response.data && response.data.message) || '上架失败，请重试');
          }
        }).catch(error => {
          console.error('上架房源错误:', error);
          this.$message.error('上架失败，请重试');
        });
    },
    handleCloseDialog() {
      if(this.rentInfoVisible) {
        this.rentInfoVisible = false;
      }
      if(this.tenantInfoVisible) {
        this.tenantInfoVisible = false;
      }
    },
    // 已出租状态的操作
    handleMarkEmptyHouse() {
      this.$confirm('确认将此房源标记为空房?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('标记空房成功');
        this.rentInfoVisible = false;
        this.getList();
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    handleRenewRent() {
      this.$message.success('续租成功');
      this.rentInfoVisible = false;
    },
    // 看房中状态的操作
    handleRescindRent() {
      this.$confirm('确认放弃租房?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('已放弃租房');
        this.tenantInfoVisible = false;
        this.getList();
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    handleCompleteRent() {
      this.$message.success('出租成功');
      this.tenantInfoVisible = false;
      this.getList();
    }
  }
}
</script>

<style scoped>
.house-list-container {
  padding: 20px;
}
.filter-container {
  margin-bottom: 20px;
}
.house-type-filter {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-info {
  color: #606266;
  font-size: 14px;
}

/* 租金信息弹框样式 */
.rent-info-dialog .section {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EBEEF5;
}
.rent-info-dialog h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
}
.rent-info-dialog .info-row {
  display: flex;
  margin-bottom: 10px;
}
.rent-info-dialog .info-item {
  flex: 1;
  display: flex;
}
.rent-info-dialog .label {
  width: 120px;
  color: #909399;
}
.rent-info-dialog .value {
  flex: 1;
  color: #303133;
}
.rent-info-dialog .tag {
  display: inline-block;
  padding: 2px 6px;
  font-size: 12px;
  color: #E6A23C;
  background-color: #FDF6EC;
  border-radius: 2px;
  margin-left: 6px;
}
.rent-info-dialog .actions {
  text-align: right;
}

/* 租客信息弹框样式 */
.tenant-info-dialog .tabs-section {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EBEEF5;
}
.tenant-info-dialog .tab-header {
  display: flex;
  margin-bottom: 15px;
}
.tenant-info-dialog .tab-item {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #F2F6FC;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tenant-info-dialog .tab-item.active {
  border: 2px solid #409EFF;
}
.tenant-info-dialog .avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tenant-info-dialog .user-info,
.tenant-info-dialog .tenant-basic-info {
  margin-bottom: 20px;
}
.tenant-info-dialog .user-row,
.tenant-info-dialog .tenant-row {
  display: flex;
  margin-bottom: 10px;
}
.tenant-info-dialog .user-field,
.tenant-info-dialog .tenant-field {
  width: 120px;
  color: #909399;
}
.tenant-info-dialog .user-value,
.tenant-info-dialog .tenant-value {
  flex: 1;
  color: #303133;
}
.tenant-info-dialog .actions {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/rentalSystem/houseList.vue